(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["satisfied-customers"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__satisfiedCustomersBound) return;
    window.__satisfiedCustomersBound = true;

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.satisfied-customers--load-more');
      if (!btn) return;

      var root = btn.closest('.satisfied-customers--root');
      if (!root) return;

      root.classList.add('is-expanded');

      var footer = btn.closest('.satisfied-customers--footer');
      if (footer) footer.style.display = 'none';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trusted-partners"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var SPEED = 60; // px per second

    function fill(root) {
      var viewport = root.querySelector('.partners--viewport');
      var track = root.querySelector('.partners--track');
      var source = root.querySelector('.partners--group');
      if (!viewport || !track || !source || !source.children.length) return;

      if (root.dataset.partnersSource == null) {
        root.dataset.partnersSource = source.innerHTML;
      }

      var items = [];
      var i;
      for (i = 0; i < source.children.length; i++) {
        items.push(source.children[i]);
      }

      var cardWidth = items[0].getBoundingClientRect().width;
      root.style.setProperty('--partner-card-width', cardWidth + 'px');

      var target = viewport.clientWidth;
      var guard = 0;
      while (source.getBoundingClientRect().width < target && guard < 200) {
        for (i = 0; i < items.length; i++) {
          source.appendChild(items[i].cloneNode(true));
          if (source.getBoundingClientRect().width >= target) break;
        }
        guard++;
      }

      var clone = source.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);

      track.style.animationDuration = (source.getBoundingClientRect().width / SPEED) + 's';
      root.classList.add('is-ready');
    }

    function rebuild(root) {
      var track = root.querySelector('.partners--track');
      var source = root.querySelector('.partners--group');
      if (!track || !source) return;

      while (track.children.length > 1) {
        track.removeChild(track.lastChild);
      }
      if (root.dataset.partnersSource != null) {
        source.innerHTML = root.dataset.partnersSource;
      }
      root.classList.remove('is-ready');
      track.style.animationDuration = '';
      fill(root);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('.trusted-partners--root');
      for (var i = 0; i < roots.length; i++) {
        fill(roots[i]);
      }
    }

    initAll();

    if (!window.__trustedPartnersBound) {
      window.__trustedPartnersBound = true;

      var timer;
      window.addEventListener('resize', function() {
        clearTimeout(timer);
        timer = setTimeout(function() {
          var roots = document.querySelectorAll('.trusted-partners--root');
          for (var i = 0; i < roots.length; i++) {
            rebuild(roots[i]);
          }
        }, 300);
      });

      document.addEventListener('shopify:section:load', function(e) {
        initAll(e.target);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
